import featureImg from "../../../../../assets/images/jewelsmith/static-page/features/feature-static-thub.png"

export const FeaturesData = [
    {
        "title": "AUGUST 2024",
        "image": featureImg,
        "link": "https://s3.ap-southeast-1.amazonaws.com/cdn.jfone.jewelflow.pro/jewelsmith/static_pages/features/pdf/Jewelsmith+RJ+recommends+pg.pdf"
    }
]